// extracted by mini-css-extract-plugin
module.exports = {"SRowContainer":"PosterRow_SRowContainer__9Nc7T","ItemContainer":"PosterRow_ItemContainer__Kbh3j","SPoster":"PosterRow_SPoster__Opvz2"};